module.exports = __webpack_public_path__ + "cd0f7af2adf12e2af6a91810840ff432.png";